import { render, staticRenderFns } from "./TermEdit.vue?vue&type=template&id=4b1e1441"
import script from "../../../controllers/custom/term/term-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/term/term-edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports